import { computed, ref } from "vue";

const getDefaultMonthYear = () => {
  const date = new Date();
  date.setMonth(date.getMonth() - 1); // Default to previous month
  return date.toISOString().slice(0, 7); // YYYY-MM format
};

/**
 * The month an LT ESO admin view works on: a "YYYY-MM" ref for the month input
 * (defaulting to the previous month) and its year and month as numbers.
 */
export function useEsoSelectedMonth() {
  const selectedMonthYear = ref<string>(getDefaultMonthYear());

  const selectedYear = computed(() =>
    parseInt(selectedMonthYear.value.split("-")[0])
  );
  const selectedMonth = computed(() =>
    parseInt(selectedMonthYear.value.split("-")[1])
  );

  return { selectedMonthYear, selectedYear, selectedMonth };
}
